import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function SklonisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="SklonisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="currentcolor" d="M72.8,44.4v1.9h-6.2v29.5h7.1v4.8H26.2v-4.8h7.2V46.4h-6.2v-1.9L50,17.8L72.8,44.4z M56.7,75.8v-19H43.4v19
	H56.7z"/>
    </svg>
  </SvgIcon>
}

export default SklonisteIcon;
